module.exports = __webpack_public_path__ + "img/Step03.82d4ba82.webp";